import {ViewCashVo} from '../../common/shared/api/nicolas/vo/billing/ViewCashVo.interface';
import {UserCash} from '../generated/types';
import {createExpiredCreditWithExpiredCredit} from './ExpiredCredit';

export function createUserCash({
  expired_credit,
  remain_cash,
  detail_balance,
}: ViewCashVo): UserCash {
  return {
    expiredCredit: expired_credit
      ? createExpiredCreditWithExpiredCredit(expired_credit)
      : undefined,
    remainCash: remain_cash,
    detail: {
      eventSum: detail_balance?.event_sum,
      paidSum: detail_balance?.paid_sum,
      totalBalance: detail_balance?.total_balance,
    },
  };
}
